<template>
  <section :class="['footer', isOverseas && 'overseas']">
    <img class="footer-logo" :src="isOverseas ? overseasLogo : logo">
    <section class="footer-content">
      <section class="footer-media">
        <div v-if="!isOverseas" class="dy" @click="jumpMedia('dy')" />
        <div v-if="isOverseas" class="dy" @click="jumpMedia('tiktok')" />
        <div v-if="!isOverseas" class="xhs" @click="jumpMedia('xhs')" />
        <div v-if="!isOverseas" class="ks" @click="jumpMedia('ks')" />
        <div v-if="isOverseas" class="ytb" @click="jumpMedia('youtube')" />
      </section>
      <section class="protocol" v-if="!isOverseas">
        <div @click="toLegal('copyright')">版权声明</div>
        <div @click="toLegal('privacy')">隐私政策</div>
        <div @click="toLegal('children')">儿童个人信息保护指引</div>
        <div @click="toLegal('user')">用户服务协议</div>
      </section>
      <section class="message" v-if="!isOverseas">
        <div>
          <p>用户咨询邮箱：service@joltrixtech.com</p>
          <p>用户咨询热线：400-990-0076</p>
        </div>
        <div>ISBN 978-7-498-17225-9</div>
        <div>
          <p @click="jumpUrl('https://beian.miit.gov.cn/#/Integrated/index')">闽ICP备2025089679号-1 </p>
          <p @click="jumpUrl('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010402351711')">闽公网安备
            35010402351711号 </p>
          <p @click="openImg()">闽网文（2025）1059-043号</p>
        </div>
        <div>
          健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适当游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
        <div>
          <p>Copyright © 2025-2026 Joltrix All Rights Reserved.  </p>
          <p>福州市跃次元网络科技有限公司</p>
        </div>
        <div>福建省福州市仓山区建新镇百花洲路44号金山工业集中区浦上片仓山园福州圣信众创网络科技有限公司提升改造项目1#楼3层302</div>
      </section>
      <!-- 海外 -->
      <section class="overseas-protocol" v-if="isOverseas">
        <p @click="toLegal('copyright')">{{ t('copyright') }}</p>
        <p @click="toLegal('privacy')">{{ t('privacy') }}</p>
        <p @click="toLegal('children')">{{ t('children') }}</p>
        <p @click="toLegal('user')">{{ t('userAgreement') }}</p>
      </section>
      <section class="overseas-message" v-if="isOverseas">{{ t('address') }}
      </section>
    </section>
  </section>
</template>

<script setup lang="ts">
import logo from "@/assets/images/footer/logo.png";
import overseasLogo from "@/assets/images/footer/overseas-logo.png";
const { isOverseas, mediaConfig, langText } = useAppState()
const localePath = useLocalePath();
const router = useRouter()
const { t } = useI18n();
const toLegal = (type: string) => {
  const localizedPath = localePath({ name: "legal" })
  router.push({ path: localizedPath, query: { type } })
}
const jumpMedia = (type: string) => {
  const ketToText = {
    xhs: '小红书',
    ks: '快手',
    dy: '抖音',
    tiktok: 'Tiktok',
    youtube: 'Youtube'
  }
  aiolosRecordEvent(isOverseas.value ? 'overseas_social' : 'domestic_social', {
    place: `底部栏${ketToText[type]}`,
    language: langText
  })
  window.open(mediaConfig[type])
}
const jumpUrl = (url: string) => {
  window.open(url)
}
const openImg = () => {
  window.open(location.origin + '/license.png')
}
</script>

<style lang="less" scoped>
.footer {
  height: 1477px;
  background: #0D1C22;
  padding: 84px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-logo {
    width: 222px;
    height: 121px;
  }

  &-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-media {
    display: flex;
    margin-top: 112px;

    div {
      width: 138px;
      height: 138px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      margin: 0 43px;
      cursor: pointer;
      background-position: center;
      background-repeat: no-repeat;
    }

    .dy {
      padding: 40px 40px 37px 43px;
      background-image: url('../../assets/images/footer/dy.png');
      background-size: 53px 61px;
    }

    .ks {
      padding: 43px 46px 37px 43px;
      background-image: url('../../assets/images/footer/ks.png');
      background-size: 50px 57px;
    }

    .xhs {
      padding: 52px 20px 52px 23px;
      background-image: url('../../assets/images/footer/xhs.png');
      background-size: 94px 35px;
    }

    .ytb {
      padding: 43px 37px 46px 37px;
      background-image: url('../../assets/images/footer/ytb.png');
      background-size: 64px 49px;
    }
  }

  .protocol {
    height: 49px;
    font-weight: 400;
    font-size: 35px;
    color: #E3E3E3;
    display: flex;
    margin-top: 104px;

    div {
      height: 35px;
      padding-left: 20px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    div:not(:last-child) {
      border-right: 1px solid #E3E3E3;
      padding-right: 30px;
    }
  }

  .overseas-protocol {
    font-weight: 400;
    font-size: 35px;
    color: #E3E3E3;
    line-height: 72px;
    text-align: center;
    margin-top: 92px;
    cursor: pointer;
  }

  .message {
    font-weight: 400;
    font-size: 29px;
    color: #949494;
    line-height: 40px;
    text-align: center;
    margin-top: 40px;
    cursor: pointer;
    -webkit-text-fill-color: #949494 !important;

    div {
      margin-top: 26px;
    }
  }

  .overseas-message {
    font-weight: 400;
    font-size: 29px;
    color: #949494;
    line-height: 40px;
    margin-top: 23px;
    text-align: center;
  }
}

.overseas {
  height: 999px;
}

@media only screen and (min-width: 768px) {


  .footer {
    width: 100%;
    height: 232px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;

    &-logo {
      width: 92px;
      height: 51px;
      margin: auto;
    }

    &-content {
      width: 50%;
      height: 100%;
      padding-right: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &-media {
      margin-top: 28px;

      div {
        margin: 0;
        margin-right: 17px;
        width: 32px;
        height: 32px;
      }

      div:hover {
        transform: scale(1.06);
        background-color: rgba(255, 255, 255, 0.26);
      }

      .dy {
        padding: 9px 10px 8px 9px;
        background-size: 13px 14px;
      }

      .ks {
        padding: 10px 10px 9px 10px;
        background-size: 11px 13px;
      }

      .xhs {
        padding: 12px 5px;
        background-size: 21px 8px;
      }

      .ytb {
        padding: 10px 8px;
        background-size: 15px 11px;
      }
    }

    .overseas-protocol {
      display: flex;
      font-weight: 400;
      font-size: 8px;
      color: #E3E3E3;
      line-height: 11px;
      margin-top: 21px;

      p:not(:last-child) {
        padding-right: 16px;
        position: relative;
      }

      p:not(:last-child)::after {
        content: '';
        position: absolute;
        display: block;
        height: 8px;
        width: 1px;
        background: #E3E3E3;
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
      }
    }

    .overseas-message {
      font-weight: 400;
      font-size: 8px;
      color: #949494;
      line-height: 11px;
      margin-top: 15px;
    }

    .protocol {
      font-size: 8px;
      line-height: 11px;
      margin-top: 21px;
      height: 11px;

      div {
        padding-left: 0px;
        height: 11px;
      }

      div:not(:last-child) {
        padding-right: 10px;
      }

      div:not(:first-child) {
        padding-left: 10px;
      }
    }

    .message {
      font-size: 8px;
      color: #949494;
      line-height: 11px;
      margin-top: 10px;
      text-align: left;

      div {
        margin-top: 5px;
        display: flex;

        p:not(:last-child) {
          padding-right: 16px;
          position: relative;
        }

        p:not(:last-child)::after {
          content: '';
          position: absolute;
          display: block;
          height: 8px;
          width: 1px;
          background: #4d5558;
          right: 8px;
          top: 1px;
        }
      }
    }
  }

  .overseas {
    height: 196px;

    .footer-media {
      margin-top: 53px;
    }
  }
}

.ar {
  .footer {
    direction: rtl;
    text-align: right;
  }

  .overseas-protocol {
    p:not(:first-child) {
      padding-right: 16px;
      position: relative;
    }

    p:not(:first-child)::after {
      content: '';
      position: absolute;
      display: block;
      height: 8px;
      width: 1px;
      background: #E3E3E3;
      right: 8px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
}
</style>